angular.module('impactx.cscontract').controller('CSCAddressesCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'TranslationService',
    'ToolbarService',
    'PartialDialogsService',
    CSCAddressesCtrl
]);

function CSCAddressesCtrl($scope, dataGen, $routeParams, ToastService, BackService, TranslationService, ToolbarService, PartialDialogsService) {
    var self = this;

    self.save = function ($event) {
        return dataGen.postAsForm($scope, {addressData: $scope.data}, "/cscontract/addresses/save").then(function (data) {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.cscId, 'cscaddresses', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    dataGen.getData($scope, {cscId: $routeParams.cscId}, "/cscontract/addresses/view").then(function () {
        $scope.additionalDataForSupplierEntryPoint = {comId: $scope.data.supplierComId};
        $scope.additionalDataForBuyerEntryPoint = {comId: $scope.data.buyerComId};

        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}